var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inquiry-order-page"},[_c('div',{staticClass:"inquiry-order-section"},[_c('ulu-inquiry-order-charts')],1),_c('div',{staticClass:"inquiry-order-section"},[_c('ulu-order-charts')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }